// extracted by mini-css-extract-plugin
export default {"cls1":"u5Sa1bURjTo4K5BVqQ60","cls2":"h0dxYU2QAcgv4Cip2Pqc u5Sa1bURjTo4K5BVqQ60","isPhone":"UyCoXMeV1fJLzYZK_Yki","bookingAppRedesign":"c_e5l5BeVgdvkmgfHvsJ"};